import { BasicComponent } from "haxt";

import "./ContactPage.scss";
import { GridSection } from "../components/sections/GridSection";

export class ContactPage extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	public render() {
		return (
			<GridSection class="ContactPage">
				<GridSection class="box form" style="grid-area: form;">
					<h2 class="box-heading">
						Get in touch
					</h2>
					<div class="box-content">
						<div class="form-input">
							<label for="subject">Subject</label>
							<input id="subject" type="text" />
						</div>
					</div>
					<div class="box">
						<div class="form-input">
							<label for="first-name">First Name</label>
							<input id="first-name" type="text" />
						</div>
					</div>
					<div class="box">
						<div class="form-input">
							<label for="first-name">Last Name</label>
							<input id="first-name" type="text" />
						</div>
					</div>
					<div class="box-content">
						<div class="form-input">
							<label for="email">Email</label>
							<input id="email" type="text" />
						</div>
					</div>
					<div class="box-content">
						<div class="form-input">
							<label for="message">Message</label>
							<textarea id="message" placeholder="Message"></textarea>
						</div>
					</div>
					<div class="box-button">
						<button>Submit</button>
					</div>
				</GridSection>
				{/* <div class="box" style="height: 600px; grid-area: image;">
					<img src="/images/contact.jpg" alt="Contact" />
				</div> */}
				{/* <div class="box details" style="height: 600px; grid-area: details;">
					<p>
						<h3>Geographical Society of Ireland</h3>
						NUIG, Galway, Ireland
					</p>
					<p>
						<h3>Phone</h3>
						091 123 456
					</p>
					<p>
						<h3>Email</h3>
						<a href="mailto:secretary@geographicalsocietyireland.ie">secretary@geographicalsocietyireland.ie</a>
					</p>
				</div> */}
			</GridSection>
		);
	}
}
